/* eslint-disable react-hooks/exhaustive-deps */

// React
import { useEffect } from "react"

// Form
import { Controller, useFormContext, useWatch } from "react-hook-form"

// Utils
import { convertNumber } from "utils"
import { DetailFormType } from "../../../utils"

export function Total() {
  // Form
  const { control, setValue } = useFormContext<DetailFormType>()
  const discount = useWatch({
    control,
    name: "discount"
  })
  const price_bill = useWatch({
    control,
    name: "price_bill"
  })
  const qty_order = useWatch({
    control,
    name: "quantity_bill"
  })

  const unit_convention = useWatch({
    control,
    name: "quantity_unit_convention"
  })

  useEffect(() => {
    setValue("total", qty_order * price_bill * (100 - discount) / 100)
    setValue("quantity_unit", qty_order * Number(unit_convention))
     // eslint-disable-next-line
  }, [discount, price_bill, qty_order])

  return (
    <Controller
      name="total"
      control={control}
      render={({ field }) => <div className="px-3 text-right">{convertNumber(field.value).intoCurrency}</div>}
    />
  )
}